import set from 'lodash/set';

export default {
  setValue(state, { accessor, value }) {
    set(state, accessor, value);
  },
  setValues(state, payload) {
    Object.keys(payload).forEach((key) => {
      set(state, key, payload[key]);
    });
  },
};
